// extracted by mini-css-extract-plugin
export default {"content":"TermsStep_content__xjxqD","terms":"TermsStep_terms__nGUyO","text":"TermsStep_text__tkSDh","list":"TermsStep_list__tU8ZJ","button":"TermsStep_button__H-hnW"};